<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-popup
    color="primary"
    title="Add Call History"
   :active.sync="isSidebarActiveLocal"
  >
    <form data-vv-scope="Add_Call"  class="sidebar-scrollable-form">
      <div class="form-holder">
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <vs-input class="w-full" label="Call Type" v-model="call_type" />
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Purchase to</label>
            <v-select
              class="w-full"
              multiple
              :reduce="(option) => option.id"
              label="name"
              placeholder="select courses"
              :closeOnSelect="false"
              v-model="courses"
              :options="courseLists"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Description</label>
            <vs-textarea
              label="Write Description here..."
              v-model="description"
              height="200px"
            />
          </vs-col>
        </vs-row>

        <file-upload
          class="file-upload"
          section_type="CourseComponent"
          :multiplefile="true"
          :file_repository_id="repository_id"
          @getFileId="getFileId"
        ></file-upload>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" class="p-1">
            <label class="vs-input--label">Feedback</label>
            <vs-textarea
              v-validate="'required'"
              placeholder="Start typing the details about the feedback...."
              v-model="feedback"
            />
          </vs-col>
        </vs-row>
      </div>

      <div class="footer-sidebar" slot="footer">
        <!-- Save & Cancel Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="closeAddForm"
            type="border"
            color="danger"
            >Cancel</vs-button
          >
          <vs-button class="ml-4 mt-2" @click.prevent="submitData"
            >Save</vs-button
          >
        </div>
      </div>
    </form>

    <!-- Edit Form -->
   

    <!-- Edit Form -->

    <!-- Data Fetching -->
    <!-- Data Fetching -->
  </vs-popup>
</template>

<script>
import {
  AddCallLogApi,
  fetchCallLogApi,
  FetchSingleCallId,
  UpdateCallLog,
  DeleteCallLog
} from '@/api/addcallLog'
import FileUpload from './callFileUpload'
import { courseListing } from '@/api/course-builderapi'
import { repository } from '@/mixins/repository.js'
import { PaginationData } from '@/mixins/pagination'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import axios from 'axios'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    leadId: {
      required: true
    }
    // notesdata:{
    //   type: Array,
    //   default: () => []
    // }
  },
  mixins: [PaginationData, repository],
  components: {
    editor: Editor,
    VuePerfectScrollbar,
    vSelect,
    FileUpload,
    flatPickr
  },
  data () {
    return {
      feedback: '',
      courses: [],
      files: [],
      courseLists: [],
      addform: false,
      editform: false,
      call_type: '',

      //task todo//

      description: '',

      //editedform
      editedCall: {
        description: '',
        file_ids: [],
        course_ids: [],
        call_type: '',
        feedback: ''
      },
      courserForlist: [],

      //editedform

      //tasktodo
      call_id: '',
      page: 1,
      filesInfo: [],
      callListdata: [],
      sidebarCallMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      //taskpage

      //boolean
      //leadid
      dataId: null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  mounted () {
    this.fetchCourseList()
    this.getRepositoryId(1)
    this.fetchCallLog()
  },

  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeCallSidebar', false)
        }
      }
    },

    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    downloadImage (item) {
      //
      axios({
        url: `https://cors-anywhere.herokuapp.com/${item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    initValues () {
      if (this.data.id) return
      this.notescontent = ''
    },
    openAddForm () {
      this.editform = false
      this.addform = true
    },
    closeAddForm () {
      this.addform = false
    },
    closeEditForm () {
      this.editform = false
    },
    openEditForm (id) {
      this.addform = false
      this.fetchSingleForm(id)
    },
    async fetchSingleForm (id) {
      try {
        const { data } = await FetchSingleCallId(id)
        
        this.call_id = id
        this.editedCall.call_type = data.data.call_log_details.call_type
        const course = data.data.call_log_details.course.map((ele) => {
          return ele.id
        })
        this.editedCall.course_ids = course
        this.editedCall.description = data.data.call_log_details.description
        this.editedCall.feedback = data.data.call_log_details.feedback
        this.filesInfo = data.data.call_log_details.files
        this.files = data.data.call_log_details.files.map((ele) => {
          return ele.files_id
        })
        
        this.editform = true
      } catch (e) {
        
      }
    },
    submitData () {
      const customerId = this.$store.getters.customerId
      const payload = {
        course_ids: this.courses,
        call_type: this.call_type,
        description: this.description,
        feedback: this.feedback,
        file_ids: this.files
      }
      
      this.addCallLog(payload, customerId, this.leadId)
      //this.initValues()
    },
    //fetch_course_list
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait ...'
        })
        const payload = {}

        payload.custom = 0

        const customer_id = this.$store.getters.customerId

        const queryParams = this.$route.query || {}
        this.query_page.page = queryParams.page || 1
        const responeList = await courseListing(
          customer_id,
          payload,
          this.query_page.page
        )
        
        this.courseLists = responeList.data.data.courselist
        this.meta = responeList.data.data.meta

        
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    getFileId (obj) {
      if (Array.isArray(obj)) {
        this.files = [...this.files, ...obj]
      } else {
        this.files.push(obj)
      }
    },
    deletedIndex (deleteIndex) {
      this.files.splice(deleteIndex, 1)
      this.filesInfo.splice(deleteIndex, 1)
    },
    //fetch_customer_list
    async addCallLog (payload, customer_id, leadId) {
      try {
        const { data } = await AddCallLogApi(payload, customer_id, leadId)

        const newData = data.data.call_log
        

        this.$emit('closeCallSidebar', newData)
      } catch (e) {
        
      }
    },
    async fetchCallLog () {
      const customerId = this.$store.getters.customerId

      const { data } = await fetchCallLogApi(
        this.page,
        this.leadId,
        customerId
      )
      
      this.callListdata = data.data.call_list
      this.courserForlist = data.data.call_list

      this.sidebarCallMeta = data.data.meta

      
    },
    initdefault () {
      this.title = ''
      this.description = ''
      this.related_to_id = []
      this.colloaborator_id = []
    },
    updateCall () {
      const payload = this.editedCall
      
      // payload.collaborator_id = this.editedCall.collaborator_id.map(({ user_id }) => user_id)

      // payload.collaborator_id = this.editedCall.collaborator_id.map(ele => ele.user_id)
      
      payload.file_ids = this.files
      this.updateData(this.editedCall, this.call_id)
    },
    async updateData (payload, id) {
      try {
        const { data } = await UpdateCallLog(payload, id)
        this.callListdata.forEach((element, index) => {
          if (element.id === id) {
            this.callListdata[index].call_type = payload.call_type
            this.callListdata[index].description = payload.description
            this.callListdata[index].feedback = payload.feedback
          }
        })
        this.$emit('closeCallSidebar', 'Call Log Updated Successfully')

        
      } catch (error) {
        
      }

      this.editform = false
      // 
    },
    infiniteHandler ($state) {
      if (this.sidebarCallMeta.has_next) {
        FetchLeadTask(this.page + 1, this.leadId).then(({ data }) => {
          this.callListdata.push(...data.data.list)
          this.sidebarCallMeta = data.data.meta

          
          this.page++
          //increment of page

          if (!this.sidebarCallMeta.has_next) {
            $state.complete()
          } else {
            $state.loaded()
          }
        })
      } else {
        $state.complete()
        
      }
    },
    DeleteCall (id) {
      this.deleteCall(id)
    },
    async deleteCall (id) {
      this.editform = false
      this.addform = false
      const data = await DeleteCallLog(id)
      const dlt_id = this.callListdata.findIndex((item) => item.id === id)
      this.callListdata.splice(dlt_id, 1)
      const msg = data.data.message
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      
    },
    handleCloseSidebar () {
      this.isSidebarActiveLocal = false
      document.body.classList.remove('overflow-hidden')
    }
  }
}
</script>

<style lang="scss" scoped>
.flatpickr-input[readonly] {
  cursor: pointer;
  width: 100%;
}
// [dir] .flatpickr-input[readonly] {
//     width: 100%;
// }

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    //z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    // z-index: 52010;
    width: 550px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: scroll;
  }
}
[dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items form {
  overflow-y: auto;
  height: calc(100vh - 195px);
}
body {
  margin: 0;
}
</style>

<style>
.add-new-data-sidebar .vs-sidebar-position-right {
  width: 480px !important;
  max-width: 480px !important;
}
.heading-holder {
  width: 80%;
}
.call-card .vs-card--content {
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .add-new-data-sidebar .vs-sidebar-position-right {
    width: 80% !important;
    max-width: 480px !important;
  }
}
</style>